export default {"src":"/_next/static/image/public/images/health_profile_icon.937151f534d86abf16119ec654e518d0.svg","height":40,"width":40};